export const IProfilesListViewModelType = Symbol('IProfilesListViewModel');
